/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdditionalNotesResponseDto,
  EnvironmentToxinsResponseDto,
  ErrorResponse,
  FamilyHistoryResponseDto,
  FertilityReproductiveHealthResponseDto,
  FunctionalLifestyleResponseDto,
  GeneralInformationResponseDto,
  GoalsOfTreatmentResponseDto,
  MedicalHistoryResponseDto,
  MedicationStatementResponseDto,
  NutritionAndDietResponseDto,
  PresentingConcernsResponseDto,
  RenameInstructionDto,
  RenameTreatmentPlanDto,
  SocialHistoryResponseDto,
  UpdateInstructionVisibilityDto,
  UpdateTreatmentPlanVisibilityDto,
} from '../models/index';
import {
    AdditionalNotesResponseDtoFromJSON,
    AdditionalNotesResponseDtoToJSON,
    EnvironmentToxinsResponseDtoFromJSON,
    EnvironmentToxinsResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FamilyHistoryResponseDtoFromJSON,
    FamilyHistoryResponseDtoToJSON,
    FertilityReproductiveHealthResponseDtoFromJSON,
    FertilityReproductiveHealthResponseDtoToJSON,
    FunctionalLifestyleResponseDtoFromJSON,
    FunctionalLifestyleResponseDtoToJSON,
    GeneralInformationResponseDtoFromJSON,
    GeneralInformationResponseDtoToJSON,
    GoalsOfTreatmentResponseDtoFromJSON,
    GoalsOfTreatmentResponseDtoToJSON,
    MedicalHistoryResponseDtoFromJSON,
    MedicalHistoryResponseDtoToJSON,
    MedicationStatementResponseDtoFromJSON,
    MedicationStatementResponseDtoToJSON,
    NutritionAndDietResponseDtoFromJSON,
    NutritionAndDietResponseDtoToJSON,
    PresentingConcernsResponseDtoFromJSON,
    PresentingConcernsResponseDtoToJSON,
    RenameInstructionDtoFromJSON,
    RenameInstructionDtoToJSON,
    RenameTreatmentPlanDtoFromJSON,
    RenameTreatmentPlanDtoToJSON,
    SocialHistoryResponseDtoFromJSON,
    SocialHistoryResponseDtoToJSON,
    UpdateInstructionVisibilityDtoFromJSON,
    UpdateInstructionVisibilityDtoToJSON,
    UpdateTreatmentPlanVisibilityDtoFromJSON,
    UpdateTreatmentPlanVisibilityDtoToJSON,
} from '../models/index';

export interface DeleteInstructionForAdminRequest {
    instructionId: string;
    patientId: string;
}

export interface DeleteTreatmentPlanForAdminRequest {
    treatmentPlanId: string;
    patientId: string;
}

export interface GetPatientAdditionalNotesForAdminRequest {
    patientId: string;
}

export interface GetPatientEnvironmentToxinsForAdminRequest {
    patientId: string;
}

export interface GetPatientFamilyHistoryForAdminRequest {
    patientId: string;
}

export interface GetPatientFertilityReproductiveHealthForAdminRequest {
    patientId: string;
}

export interface GetPatientFunctionalLifestyleForAdminRequest {
    patientId: string;
}

export interface GetPatientGeneralInformationForAdminRequest {
    patientId: string;
}

export interface GetPatientGoalsOfTreatmentForAdminRequest {
    patientId: string;
}

export interface GetPatientMedicalHistoryForAdminRequest {
    patientId: string;
}

export interface GetPatientMedicationsForAdminRequest {
    patientId: string;
}

export interface GetPatientNutritionAndDietForAdminRequest {
    patientId: string;
}

export interface GetPatientPresentingConcernsForAdminRequest {
    patientId: string;
}

export interface GetPatientSocialHistoryForAdminRequest {
    patientId: string;
}

export interface RenameInstructionForAdminRequest {
    patientId: string;
    instructionId: string;
    renameInstructionDto: RenameInstructionDto;
}

export interface RenameTreatmentPlanForAdminRequest {
    patientId: string;
    treatmentPlanId: string;
    renameTreatmentPlanDto: RenameTreatmentPlanDto;
}

export interface RestrictPatientForAdminRequest {
    patientId: string;
}

export interface UnrestrictPatientForAdminRequest {
    patientId: string;
}

export interface UpdateInstructionVisibilityForAdminRequest {
    patientId: string;
    instructionId: string;
    updateInstructionVisibilityDto: UpdateInstructionVisibilityDto;
}

export interface UpdateTreatmentPlanVisibilityForAdminRequest {
    patientId: string;
    treatmentPlanId: string;
    updateTreatmentPlanVisibilityDto: UpdateTreatmentPlanVisibilityDto;
}

/**
 * 
 */
export class AdminPatientDetailApi extends runtime.BaseAPI {

    /**
     * Soft-deletes an instruction by ID. Admin can delete any instruction regardless of ownership.
     * Delete an instruction (Admin only)
     */
    async deleteInstructionForAdminRaw(requestParameters: DeleteInstructionForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling deleteInstructionForAdmin().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling deleteInstructionForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/instructions/{instructionId}`.replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-deletes an instruction by ID. Admin can delete any instruction regardless of ownership.
     * Delete an instruction (Admin only)
     */
    async deleteInstructionForAdmin(requestParameters: DeleteInstructionForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInstructionForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Soft-deletes a treatment plan by ID. Admin can delete any treatment plan regardless of ownership.
     * Delete a treatment plan (Admin only)
     */
    async deleteTreatmentPlanForAdminRaw(requestParameters: DeleteTreatmentPlanForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['treatmentPlanId'] == null) {
            throw new runtime.RequiredError(
                'treatmentPlanId',
                'Required parameter "treatmentPlanId" was null or undefined when calling deleteTreatmentPlanForAdmin().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling deleteTreatmentPlanForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/treatment-plans/{treatmentPlanId}`.replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(requestParameters['treatmentPlanId']))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-deletes a treatment plan by ID. Admin can delete any treatment plan regardless of ownership.
     * Delete a treatment plan (Admin only)
     */
    async deleteTreatmentPlanForAdmin(requestParameters: DeleteTreatmentPlanForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTreatmentPlanForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve additional practitioner notes stored for a patient profile
     * Get patient additional notes (admin)
     */
    async getPatientAdditionalNotesForAdminRaw(requestParameters: GetPatientAdditionalNotesForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdditionalNotesResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientAdditionalNotesForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/additional-notes`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdditionalNotesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve additional practitioner notes stored for a patient profile
     * Get patient additional notes (admin)
     */
    async getPatientAdditionalNotesForAdmin(requestParameters: GetPatientAdditionalNotesForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdditionalNotesResponseDto> {
        const response = await this.getPatientAdditionalNotesForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve information about a patient\'s environmental exposure and toxins
     * Get patient environment & toxins data (admin)
     */
    async getPatientEnvironmentToxinsForAdminRaw(requestParameters: GetPatientEnvironmentToxinsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnvironmentToxinsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientEnvironmentToxinsForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/environment-toxins`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentToxinsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve information about a patient\'s environmental exposure and toxins
     * Get patient environment & toxins data (admin)
     */
    async getPatientEnvironmentToxinsForAdmin(requestParameters: GetPatientEnvironmentToxinsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnvironmentToxinsResponseDto> {
        const response = await this.getPatientEnvironmentToxinsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a patient\'s family medical history information as an administrator
     * Get patient family history (admin)
     */
    async getPatientFamilyHistoryForAdminRaw(requestParameters: GetPatientFamilyHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientFamilyHistoryForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/family-history`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve a patient\'s family medical history information as an administrator
     * Get patient family history (admin)
     */
    async getPatientFamilyHistoryForAdmin(requestParameters: GetPatientFamilyHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyHistoryResponseDto> {
        const response = await this.getPatientFamilyHistoryForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the fertility and reproductive health intake for a patient
     * Get patient fertility & reproductive health intake (admin)
     */
    async getPatientFertilityReproductiveHealthForAdminRaw(requestParameters: GetPatientFertilityReproductiveHealthForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FertilityReproductiveHealthResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientFertilityReproductiveHealthForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/fertility-reproductive-health`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FertilityReproductiveHealthResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the fertility and reproductive health intake for a patient
     * Get patient fertility & reproductive health intake (admin)
     */
    async getPatientFertilityReproductiveHealthForAdmin(requestParameters: GetPatientFertilityReproductiveHealthForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FertilityReproductiveHealthResponseDto> {
        const response = await this.getPatientFertilityReproductiveHealthForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the functional and lifestyle questionnaire responses for a patient
     * Get patient functional & lifestyle assessment (admin)
     */
    async getPatientFunctionalLifestyleForAdminRaw(requestParameters: GetPatientFunctionalLifestyleForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionalLifestyleResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientFunctionalLifestyleForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/functional-lifestyle`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionalLifestyleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the functional and lifestyle questionnaire responses for a patient
     * Get patient functional & lifestyle assessment (admin)
     */
    async getPatientFunctionalLifestyleForAdmin(requestParameters: GetPatientFunctionalLifestyleForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionalLifestyleResponseDto> {
        const response = await this.getPatientFunctionalLifestyleForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve core demographic details for a patient as an administrator
     * Get patient general information (admin)
     */
    async getPatientGeneralInformationForAdminRaw(requestParameters: GetPatientGeneralInformationForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralInformationResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientGeneralInformationForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/general-information`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralInformationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve core demographic details for a patient as an administrator
     * Get patient general information (admin)
     */
    async getPatientGeneralInformationForAdmin(requestParameters: GetPatientGeneralInformationForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralInformationResponseDto> {
        const response = await this.getPatientGeneralInformationForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the goals of treatment defined for a patient as an administrator
     * Get patient goals of treatment (admin)
     */
    async getPatientGoalsOfTreatmentForAdminRaw(requestParameters: GetPatientGoalsOfTreatmentForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoalsOfTreatmentResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientGoalsOfTreatmentForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/goals-of-treatment`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoalsOfTreatmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the goals of treatment defined for a patient as an administrator
     * Get patient goals of treatment (admin)
     */
    async getPatientGoalsOfTreatmentForAdmin(requestParameters: GetPatientGoalsOfTreatmentForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoalsOfTreatmentResponseDto> {
        const response = await this.getPatientGoalsOfTreatmentForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the complete medical history questionnaire for a patient
     * Get patient medical history (admin)
     */
    async getPatientMedicalHistoryForAdminRaw(requestParameters: GetPatientMedicalHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientMedicalHistoryForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/medical-history`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the complete medical history questionnaire for a patient
     * Get patient medical history (admin)
     */
    async getPatientMedicalHistoryForAdmin(requestParameters: GetPatientMedicalHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalHistoryResponseDto> {
        const response = await this.getPatientMedicalHistoryForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the list of medication statements recorded for a patient
     * Get patient medication statements (admin)
     */
    async getPatientMedicationsForAdminRaw(requestParameters: GetPatientMedicationsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationStatementResponseDto>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientMedicationsForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/medication-statements`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationStatementResponseDtoFromJSON));
    }

    /**
     * Retrieve the list of medication statements recorded for a patient
     * Get patient medication statements (admin)
     */
    async getPatientMedicationsForAdmin(requestParameters: GetPatientMedicationsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationStatementResponseDto>> {
        const response = await this.getPatientMedicationsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve nutrition and diet questionnaire responses for a patient
     * Get patient nutrition & diet information (admin)
     */
    async getPatientNutritionAndDietForAdminRaw(requestParameters: GetPatientNutritionAndDietForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NutritionAndDietResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientNutritionAndDietForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/nutrition-diets`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NutritionAndDietResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve nutrition and diet questionnaire responses for a patient
     * Get patient nutrition & diet information (admin)
     */
    async getPatientNutritionAndDietForAdmin(requestParameters: GetPatientNutritionAndDietForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NutritionAndDietResponseDto> {
        const response = await this.getPatientNutritionAndDietForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve presenting concerns submitted by a patient for administrative review
     * Get patient presenting concerns (admin)
     */
    async getPatientPresentingConcernsForAdminRaw(requestParameters: GetPatientPresentingConcernsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentingConcernsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientPresentingConcernsForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/presenting-concerns`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentingConcernsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve presenting concerns submitted by a patient for administrative review
     * Get patient presenting concerns (admin)
     */
    async getPatientPresentingConcernsForAdmin(requestParameters: GetPatientPresentingConcernsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentingConcernsResponseDto> {
        const response = await this.getPatientPresentingConcernsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve social and lifestyle history information for a patient
     * Get patient social history (admin)
     */
    async getPatientSocialHistoryForAdminRaw(requestParameters: GetPatientSocialHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SocialHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientSocialHistoryForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/social-history`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SocialHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve social and lifestyle history information for a patient
     * Get patient social history (admin)
     */
    async getPatientSocialHistoryForAdmin(requestParameters: GetPatientSocialHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SocialHistoryResponseDto> {
        const response = await this.getPatientSocialHistoryForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets a custom display name for an instruction. Admin can rename any instruction.
     * Rename an instruction (admin)
     */
    async renameInstructionForAdminRaw(requestParameters: RenameInstructionForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling renameInstructionForAdmin().'
            );
        }

        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling renameInstructionForAdmin().'
            );
        }

        if (requestParameters['renameInstructionDto'] == null) {
            throw new runtime.RequiredError(
                'renameInstructionDto',
                'Required parameter "renameInstructionDto" was null or undefined when calling renameInstructionForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/instructions/{instructionId}/rename`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameInstructionDtoToJSON(requestParameters['renameInstructionDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets a custom display name for an instruction. Admin can rename any instruction.
     * Rename an instruction (admin)
     */
    async renameInstructionForAdmin(requestParameters: RenameInstructionForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameInstructionForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Sets a custom display name for a treatment plan. Admin can rename any treatment plan.
     * Rename a treatment plan (admin)
     */
    async renameTreatmentPlanForAdminRaw(requestParameters: RenameTreatmentPlanForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling renameTreatmentPlanForAdmin().'
            );
        }

        if (requestParameters['treatmentPlanId'] == null) {
            throw new runtime.RequiredError(
                'treatmentPlanId',
                'Required parameter "treatmentPlanId" was null or undefined when calling renameTreatmentPlanForAdmin().'
            );
        }

        if (requestParameters['renameTreatmentPlanDto'] == null) {
            throw new runtime.RequiredError(
                'renameTreatmentPlanDto',
                'Required parameter "renameTreatmentPlanDto" was null or undefined when calling renameTreatmentPlanForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/treatment-plans/{treatmentPlanId}/rename`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(requestParameters['treatmentPlanId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameTreatmentPlanDtoToJSON(requestParameters['renameTreatmentPlanDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets a custom display name for a treatment plan. Admin can rename any treatment plan.
     * Rename a treatment plan (admin)
     */
    async renameTreatmentPlanForAdmin(requestParameters: RenameTreatmentPlanForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameTreatmentPlanForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Restricts a patient account, revoking their access tokens and forcing logout. Admin can restrict any patient regardless of practice.
     * Restrict a patient account (admin)
     */
    async restrictPatientForAdminRaw(requestParameters: RestrictPatientForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling restrictPatientForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/restrict`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Restricts a patient account, revoking their access tokens and forcing logout. Admin can restrict any patient regardless of practice.
     * Restrict a patient account (admin)
     */
    async restrictPatientForAdmin(requestParameters: RestrictPatientForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.restrictPatientForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Restores access for a previously restricted patient account. Admin can unrestrict any patient regardless of practice.
     * Unrestrict a patient account (admin)
     */
    async unrestrictPatientForAdminRaw(requestParameters: UnrestrictPatientForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling unrestrictPatientForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/unrestrict`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Restores access for a previously restricted patient account. Admin can unrestrict any patient regardless of practice.
     * Unrestrict a patient account (admin)
     */
    async unrestrictPatientForAdmin(requestParameters: UnrestrictPatientForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unrestrictPatientForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Hides or shows an instruction from the patient. Admin can toggle visibility for any instruction.
     * Toggle instruction visibility for patient (admin)
     */
    async updateInstructionVisibilityForAdminRaw(requestParameters: UpdateInstructionVisibilityForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling updateInstructionVisibilityForAdmin().'
            );
        }

        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling updateInstructionVisibilityForAdmin().'
            );
        }

        if (requestParameters['updateInstructionVisibilityDto'] == null) {
            throw new runtime.RequiredError(
                'updateInstructionVisibilityDto',
                'Required parameter "updateInstructionVisibilityDto" was null or undefined when calling updateInstructionVisibilityForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/instructions/{instructionId}/visibility`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstructionVisibilityDtoToJSON(requestParameters['updateInstructionVisibilityDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Hides or shows an instruction from the patient. Admin can toggle visibility for any instruction.
     * Toggle instruction visibility for patient (admin)
     */
    async updateInstructionVisibilityForAdmin(requestParameters: UpdateInstructionVisibilityForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateInstructionVisibilityForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Hides or shows a treatment plan from the patient. Admin can toggle visibility for any treatment plan.
     * Toggle treatment plan visibility for patient (admin)
     */
    async updateTreatmentPlanVisibilityForAdminRaw(requestParameters: UpdateTreatmentPlanVisibilityForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling updateTreatmentPlanVisibilityForAdmin().'
            );
        }

        if (requestParameters['treatmentPlanId'] == null) {
            throw new runtime.RequiredError(
                'treatmentPlanId',
                'Required parameter "treatmentPlanId" was null or undefined when calling updateTreatmentPlanVisibilityForAdmin().'
            );
        }

        if (requestParameters['updateTreatmentPlanVisibilityDto'] == null) {
            throw new runtime.RequiredError(
                'updateTreatmentPlanVisibilityDto',
                'Required parameter "updateTreatmentPlanVisibilityDto" was null or undefined when calling updateTreatmentPlanVisibilityForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/treatment-plans/{treatmentPlanId}/visibility`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(requestParameters['treatmentPlanId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTreatmentPlanVisibilityDtoToJSON(requestParameters['updateTreatmentPlanVisibilityDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Hides or shows a treatment plan from the patient. Admin can toggle visibility for any treatment plan.
     * Toggle treatment plan visibility for patient (admin)
     */
    async updateTreatmentPlanVisibilityForAdmin(requestParameters: UpdateTreatmentPlanVisibilityForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTreatmentPlanVisibilityForAdminRaw(requestParameters, initOverrides);
    }

}
